import { Mark } from '@tiptap/core'

const GlobalVariable = Mark.create({
  name: 'globalVariable',

  addAttributes () {
    return {
      variable: {
        default: null,
        parseHTML: element => element.getAttribute('data-gvar') || null,
        renderHTML: attrs => ({
          'data-gvar': attrs.variable
        })
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'span-var[data-gvar]'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['span-var', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      globalVariable: attrs => ({ state, dispatch }) => {
        const { from, to } = state.selection
        const type = this.type
        let tr = state.tr

        if (attrs && attrs.remove) {
          tr = tr.removeMark(from, to, type)

          const selectedText = state.doc.textBetween(from, to, ' ')
          const cleanedText = selectedText.replace(/{{\s*[^}]+\s*}}/, '').trim()

          if (cleanedText) {
            tr = tr.insertText(cleanedText, from, to)
          } else {
            tr = tr.delete(from, to)
          }

          if (dispatch) {
            dispatch(tr.scrollIntoView())
          }

          return true
        }

        tr = tr.removeMark(from, to, type)
        tr = tr.delete(from, to)

        const variableText = `{{ ${attrs.variable} }}`
        const textNode = state.schema.text(variableText, [type.create(attrs)])
        tr = tr.insert(from, textNode)

        if (dispatch) {
          dispatch(tr.scrollIntoView())
        }

        return true
      }
    }
  }
})

export default GlobalVariable
